export default "__VITE_ASSET__CKG$FIcj__"